import React, {useEffect, useState} from 'react'
import {Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import Button from 'components/Button';
import GridBlock from 'components/GridBlock';
import ContractorTable from 'components/complex/contractor/ContractorTable';
import InviteContactor from 'components/popup/inviteContactor/InviteContactor';
import AddContactor from 'components/popup/addContactor/AddContactor';
import {withRouter} from "react-router";
import ContractorService from 'services/ContractorService';
import {connect} from 'react-redux'
import Form from 'components/Form';
import {DemandValidation} from 'constants/DemandValidation';
import {isDemandModification} from "libs/getDemandStatus";
import ModificationService from "services/ModificationService";
import ValidationShema from "constants/ValidationShema";
import DemandValidationMessages from "components/DemandValidationMessages";

const style = theme => ({
    root: {},
    marginLeft: {
        marginLeft: theme.spacing(2)
    }
})

function ContactorPage(
    {
        classes,
        match,
        contractorList,
        demandValidation
    }) {
    const [invitePopup, setInvitePopup] = useState(false)
    const [addPopup, setAddPopup] = useState(false)
    const demandId = match.params.id;
    const section = demandValidation.find(x => x.section === DemandValidation.CONTRACTOR);
    const editable = section ? section.editable : true;


    useEffect(() => {
        ContractorService.getList(demandId);
        return () => ContractorService.clearResources(ContractorService.CONTRACTOR_LIST_ID)
        // eslint-disable-next-line
    }, [demandId])

    const handleSubmit = () => {
        ContractorService.save(demandId)
    }


    const handleDelete = (data) => {
        ContractorService.deleteUser(match.params.id, data)
    }


    const handleInvite = (values) => {
        ContractorService.invite(demandId, values)
        setInvitePopup(false);
    }

    function addContractorsTab(data) {
        ContractorService.sendTabContractor(demandId, data.platformAdded)
        setAddPopup(false);
    }

    return (
        <Form
            onSubmit={handleSubmit}
            id='mp_1_contractor'
            validationSchema={ValidationShema.any()}
            afterSubmitFunc={() => {
                if (isDemandModification()) {
                    ModificationService.isDemandChanged(match.params.id);
                }
            }}
        >
            {() => (
                <>
                    <DemandValidationMessages section={section} editable={editable}/>
                    <Typography variant='h6'>
                        {Tr('selected_contractors_list')}
                    </Typography>
                    <GridBlock>
                        {editable && <>
                            <Button
                                onClick={() => setAddPopup(true)}
                            >
                                {Tr('add_contractor')}
                            </Button>
                            <Button
                                className={classes.marginLeft}
                                onClick={() => setInvitePopup(true)}
                            >
                                {Tr('suggest_contractor')}
                            </Button>
                        </>}
                    </GridBlock>
                    <ContractorTable
                        contractors={contractorList}
                        handleDelete={editable ? handleDelete : undefined}
                    />
                    {invitePopup && <InviteContactor
                        demandId={demandId}
                        open
                        onClose={() => setInvitePopup(false)}
                        title={Tr('invitation_contractor')}
                        contractorList={contractorList}
                        handleInvite={handleInvite}
                        collectPostCode
                        collectAddress
                        addressRequired={false}
                        collectCity
                        cityRequired={false}
                    />}
                    {addPopup && <AddContactor
                        demandId={demandId}
                        onClose={() => setAddPopup(false)}
                        addContractorsTab={addContractorsTab}
                    />}
                </>
            )}
        </Form>
    )
}

ContactorPage.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    contractorList: state.resources.contractorList,
    demandValidation: state.resources.demandValidation,
}), {})(withStyles(style)(withRouter(ContactorPage)));
